import { verifyLicence as verifyWith, type Licence as LicenceOf } from '@umpry/licence';
import { LICENCE_PUBLIC_KEYS } from './licenceKeys';

export { signLicence } from '@umpry/licence';

/** What a licence can unlock: creating an account (docs/plans/local-mode.md), which the app
 * otherwise works without. Signing into one that exists needs no licence. */
export type Unlock = 'account';

export const UNLOCKS: Unlock[] = ['account'];

/** A licence: given or sold to `email`, unlocking `unlocks`. `id` tells one from another. */
export type Licence = LicenceOf<Unlock>;

/** The licence a code holds, if it was signed by one of the keys in lib/licenceKeys; null for
 * anything else. The signing and checking themselves are in @umpry/licence, shared with Blackbox. */
export const verifyLicence = (code: string, publicKeys: JsonWebKey[] = LICENCE_PUBLIC_KEYS): Promise<Licence | null> =>
  verifyWith(code, { publicKeys, unlocks: UNLOCKS });
